/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createDgtPdProductionOrder = /* GraphQL */ `
  mutation CreateDgtPdProductionOrder(
    $input: CreateDgtPdProductionOrderInput!
    $condition: ModelDgtPdProductionOrderConditionInput
  ) {
    createDgtPdProductionOrder(input: $input, condition: $condition) {
      id
      materialType
      materialCode
      materialDescription
      materialMrp
      orderQty
      materialUnit
      dueDate
      actualDueDate
      batchNumbers
      actualBatchNumbers
      trialBatch
      statusFromSap
      statusFromApp
      countEditWorkCenter
      countEditOperation
      releaseNo
      releasedBy
      totalYield
      division
      _ttl
      tags
      createdAt
      updatedAt
      infoEffBulkDate
      infoFwt
      infoPallet
      infoRefPkg
      infoPacking
      barcodeFgCase
      orderType
      fgInspectionTypes
      infoEaPerPack
      shelfLife
      barcodeEa
      alternativeText
      shelfLifeMonth
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdProductionOrder = /* GraphQL */ `
  mutation UpdateDgtPdProductionOrder(
    $input: UpdateDgtPdProductionOrderInput!
    $condition: ModelDgtPdProductionOrderConditionInput
  ) {
    updateDgtPdProductionOrder(input: $input, condition: $condition) {
      id
      materialType
      materialCode
      materialDescription
      materialMrp
      orderQty
      materialUnit
      dueDate
      actualDueDate
      batchNumbers
      actualBatchNumbers
      trialBatch
      statusFromSap
      statusFromApp
      countEditWorkCenter
      countEditOperation
      releaseNo
      releasedBy
      totalYield
      division
      _ttl
      tags
      createdAt
      updatedAt
      infoEffBulkDate
      infoFwt
      infoPallet
      infoRefPkg
      infoPacking
      barcodeFgCase
      orderType
      fgInspectionTypes
      infoEaPerPack
      shelfLife
      barcodeEa
      alternativeText
      shelfLifeMonth
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdProductionOrder = /* GraphQL */ `
  mutation DeleteDgtPdProductionOrder(
    $input: DeleteDgtPdProductionOrderInput!
    $condition: ModelDgtPdProductionOrderConditionInput
  ) {
    deleteDgtPdProductionOrder(input: $input, condition: $condition) {
      id
      materialType
      materialCode
      materialDescription
      materialMrp
      orderQty
      materialUnit
      dueDate
      actualDueDate
      batchNumbers
      actualBatchNumbers
      trialBatch
      statusFromSap
      statusFromApp
      countEditWorkCenter
      countEditOperation
      releaseNo
      releasedBy
      totalYield
      division
      _ttl
      tags
      createdAt
      updatedAt
      infoEffBulkDate
      infoFwt
      infoPallet
      infoRefPkg
      infoPacking
      barcodeFgCase
      orderType
      fgInspectionTypes
      infoEaPerPack
      shelfLife
      barcodeEa
      alternativeText
      shelfLifeMonth
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderOperation = /* GraphQL */ `
  mutation CreateDgtPdOrderOperation(
    $input: CreateDgtPdOrderOperationInput!
    $condition: ModelDgtPdOrderOperationConditionInput
  ) {
    createDgtPdOrderOperation(input: $input, condition: $condition) {
      id
      productionOrderId
      operationNo
      workCenterId
      workCenterDescription
      actualWorkCenterId
      actualWorkCenterDescription
      status
      active
      createdBySystem
      draftedDate
      draftedBy
      confirmedDate
      confirmedBy
      confirmationId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderOperation = /* GraphQL */ `
  mutation UpdateDgtPdOrderOperation(
    $input: UpdateDgtPdOrderOperationInput!
    $condition: ModelDgtPdOrderOperationConditionInput
  ) {
    updateDgtPdOrderOperation(input: $input, condition: $condition) {
      id
      productionOrderId
      operationNo
      workCenterId
      workCenterDescription
      actualWorkCenterId
      actualWorkCenterDescription
      status
      active
      createdBySystem
      draftedDate
      draftedBy
      confirmedDate
      confirmedBy
      confirmationId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderOperation = /* GraphQL */ `
  mutation DeleteDgtPdOrderOperation(
    $input: DeleteDgtPdOrderOperationInput!
    $condition: ModelDgtPdOrderOperationConditionInput
  ) {
    deleteDgtPdOrderOperation(input: $input, condition: $condition) {
      id
      productionOrderId
      operationNo
      workCenterId
      workCenterDescription
      actualWorkCenterId
      actualWorkCenterDescription
      status
      active
      createdBySystem
      draftedDate
      draftedBy
      confirmedDate
      confirmedBy
      confirmationId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderOperationLog = /* GraphQL */ `
  mutation CreateDgtPdOrderOperationLog(
    $input: CreateDgtPdOrderOperationLogInput!
    $condition: ModelDgtPdOrderOperationLogConditionInput
  ) {
    createDgtPdOrderOperationLog(input: $input, condition: $condition) {
      id
      timeType
      productionOrderId
      operationNo
      batchNo
      postingDate
      workCenterId
      workCenterDescription
      actualWorkCenterId
      shift
      mch
      startedTime
      finishedTime
      totalTime
      totalEmployeeRT
      totalEmployeeOT
      laborTimeRT
      laborTimeOT
      yield
      scrap
      bulkUsedQty
      downtimeCode
      downtimeDescription
      downtimeBaseTime
      workingStatus
      pdOrderOperationId
      _ttl
      createdBy
      createdAt
      updatedBy
      updatedAt
      split
      confirmedDate
      confirmedBy
      confirmationId
      bulkStatus
      bulkStatusDate
      bulkStatusDateTime
      bulkStatusBy
      bulkStatusComment
      approveBulkStatusDate
      approveBulkStatusDateTime
      approveBulkStatusBy
      createdVersion
      updatedVersion
      materialCode
      materialDescription
      orderType
      orderQty
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderOperationLog = /* GraphQL */ `
  mutation UpdateDgtPdOrderOperationLog(
    $input: UpdateDgtPdOrderOperationLogInput!
    $condition: ModelDgtPdOrderOperationLogConditionInput
  ) {
    updateDgtPdOrderOperationLog(input: $input, condition: $condition) {
      id
      timeType
      productionOrderId
      operationNo
      batchNo
      postingDate
      workCenterId
      workCenterDescription
      actualWorkCenterId
      shift
      mch
      startedTime
      finishedTime
      totalTime
      totalEmployeeRT
      totalEmployeeOT
      laborTimeRT
      laborTimeOT
      yield
      scrap
      bulkUsedQty
      downtimeCode
      downtimeDescription
      downtimeBaseTime
      workingStatus
      pdOrderOperationId
      _ttl
      createdBy
      createdAt
      updatedBy
      updatedAt
      split
      confirmedDate
      confirmedBy
      confirmationId
      bulkStatus
      bulkStatusDate
      bulkStatusDateTime
      bulkStatusBy
      bulkStatusComment
      approveBulkStatusDate
      approveBulkStatusDateTime
      approveBulkStatusBy
      createdVersion
      updatedVersion
      materialCode
      materialDescription
      orderType
      orderQty
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderOperationLog = /* GraphQL */ `
  mutation DeleteDgtPdOrderOperationLog(
    $input: DeleteDgtPdOrderOperationLogInput!
    $condition: ModelDgtPdOrderOperationLogConditionInput
  ) {
    deleteDgtPdOrderOperationLog(input: $input, condition: $condition) {
      id
      timeType
      productionOrderId
      operationNo
      batchNo
      postingDate
      workCenterId
      workCenterDescription
      actualWorkCenterId
      shift
      mch
      startedTime
      finishedTime
      totalTime
      totalEmployeeRT
      totalEmployeeOT
      laborTimeRT
      laborTimeOT
      yield
      scrap
      bulkUsedQty
      downtimeCode
      downtimeDescription
      downtimeBaseTime
      workingStatus
      pdOrderOperationId
      _ttl
      createdBy
      createdAt
      updatedBy
      updatedAt
      split
      confirmedDate
      confirmedBy
      confirmationId
      bulkStatus
      bulkStatusDate
      bulkStatusDateTime
      bulkStatusBy
      bulkStatusComment
      approveBulkStatusDate
      approveBulkStatusDateTime
      approveBulkStatusBy
      createdVersion
      updatedVersion
      materialCode
      materialDescription
      orderType
      orderQty
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderReasonCode = /* GraphQL */ `
  mutation CreateDgtPdOrderReasonCode(
    $input: CreateDgtPdOrderReasonCodeInput!
    $condition: ModelDgtPdOrderReasonCodeConditionInput
  ) {
    createDgtPdOrderReasonCode(input: $input, condition: $condition) {
      id
      productionOrderId
      releaseNo
      materialCode
      labOffice
      materialDescription
      unit
      reasonCodes
      confirmedDate
      confirmedBy
      confirmStatus
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderReasonCode = /* GraphQL */ `
  mutation UpdateDgtPdOrderReasonCode(
    $input: UpdateDgtPdOrderReasonCodeInput!
    $condition: ModelDgtPdOrderReasonCodeConditionInput
  ) {
    updateDgtPdOrderReasonCode(input: $input, condition: $condition) {
      id
      productionOrderId
      releaseNo
      materialCode
      labOffice
      materialDescription
      unit
      reasonCodes
      confirmedDate
      confirmedBy
      confirmStatus
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderReasonCode = /* GraphQL */ `
  mutation DeleteDgtPdOrderReasonCode(
    $input: DeleteDgtPdOrderReasonCodeInput!
    $condition: ModelDgtPdOrderReasonCodeConditionInput
  ) {
    deleteDgtPdOrderReasonCode(input: $input, condition: $condition) {
      id
      productionOrderId
      releaseNo
      materialCode
      labOffice
      materialDescription
      unit
      reasonCodes
      confirmedDate
      confirmedBy
      confirmStatus
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdDowntimeCode = /* GraphQL */ `
  mutation CreateDgtPdDowntimeCode(
    $input: CreateDgtPdDowntimeCodeInput!
    $condition: ModelDgtPdDowntimeCodeConditionInput
  ) {
    createDgtPdDowntimeCode(input: $input, condition: $condition) {
      id
      description
      active
      baseTimeForBulk
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdDowntimeCode = /* GraphQL */ `
  mutation UpdateDgtPdDowntimeCode(
    $input: UpdateDgtPdDowntimeCodeInput!
    $condition: ModelDgtPdDowntimeCodeConditionInput
  ) {
    updateDgtPdDowntimeCode(input: $input, condition: $condition) {
      id
      description
      active
      baseTimeForBulk
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdDowntimeCode = /* GraphQL */ `
  mutation DeleteDgtPdDowntimeCode(
    $input: DeleteDgtPdDowntimeCodeInput!
    $condition: ModelDgtPdDowntimeCodeConditionInput
  ) {
    deleteDgtPdDowntimeCode(input: $input, condition: $condition) {
      id
      description
      active
      baseTimeForBulk
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdWorkCenter = /* GraphQL */ `
  mutation CreateDgtPdWorkCenter(
    $input: CreateDgtPdWorkCenterInput!
    $condition: ModelDgtPdWorkCenterConditionInput
  ) {
    createDgtPdWorkCenter(input: $input, condition: $condition) {
      id
      plant
      description
      active
      iotId
      isRequiredManHour
      isRequiredBatchLotNo
      isRequiredFGInspect
      machineCategory
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdWorkCenter = /* GraphQL */ `
  mutation UpdateDgtPdWorkCenter(
    $input: UpdateDgtPdWorkCenterInput!
    $condition: ModelDgtPdWorkCenterConditionInput
  ) {
    updateDgtPdWorkCenter(input: $input, condition: $condition) {
      id
      plant
      description
      active
      iotId
      isRequiredManHour
      isRequiredBatchLotNo
      isRequiredFGInspect
      machineCategory
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdWorkCenter = /* GraphQL */ `
  mutation DeleteDgtPdWorkCenter(
    $input: DeleteDgtPdWorkCenterInput!
    $condition: ModelDgtPdWorkCenterConditionInput
  ) {
    deleteDgtPdWorkCenter(input: $input, condition: $condition) {
      id
      plant
      description
      active
      iotId
      isRequiredManHour
      isRequiredBatchLotNo
      isRequiredFGInspect
      machineCategory
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderPicklist = /* GraphQL */ `
  mutation CreateDgtPdOrderPicklist(
    $input: CreateDgtPdOrderPicklistInput!
    $condition: ModelDgtPdOrderPicklistConditionInput
  ) {
    createDgtPdOrderPicklist(input: $input, condition: $condition) {
      pk
      sk
      materialType
      materialCode
      materialDescription
      materialMrp
      orderQty
      materialUnit
      division
      kiNo
      batchLotNo
      trialBatch
      status
      returnStatus
      releasedDate
      releasedBy
      requestQty
      requestedDate
      requestedDateTime
      requestedBy
      withdrawQty
      draftedDate
      draftedBy
      approvedDate
      approvedDateTime
      approvedBy
      checkedDate
      checkedDateTime
      checkedBy
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      usedGoodQty
      usedWasteQty
      recordedDate
      recordedDateTime
      recordedBy
      completedDate
      completedDateTime
      completedBy
      returnGoodQty
      returnWasteQty
      receivedReturnDateTime
      receivedReturnBy
      commentText
      commentedBy
      commentActive
      id
      extraReturnId
      deprecated
      shortageItems
      externalBom
      createdAt
      infoEffBulkDate
      infoFwt
      infoPallet
      infoRefPkg
      infoPacking
      barcodeFgCase
      barcodePkg
      orderType
      receiveDate
      barcodeEa
      alternativeText
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderPicklist = /* GraphQL */ `
  mutation UpdateDgtPdOrderPicklist(
    $input: UpdateDgtPdOrderPicklistInput!
    $condition: ModelDgtPdOrderPicklistConditionInput
  ) {
    updateDgtPdOrderPicklist(input: $input, condition: $condition) {
      pk
      sk
      materialType
      materialCode
      materialDescription
      materialMrp
      orderQty
      materialUnit
      division
      kiNo
      batchLotNo
      trialBatch
      status
      returnStatus
      releasedDate
      releasedBy
      requestQty
      requestedDate
      requestedDateTime
      requestedBy
      withdrawQty
      draftedDate
      draftedBy
      approvedDate
      approvedDateTime
      approvedBy
      checkedDate
      checkedDateTime
      checkedBy
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      usedGoodQty
      usedWasteQty
      recordedDate
      recordedDateTime
      recordedBy
      completedDate
      completedDateTime
      completedBy
      returnGoodQty
      returnWasteQty
      receivedReturnDateTime
      receivedReturnBy
      commentText
      commentedBy
      commentActive
      id
      extraReturnId
      deprecated
      shortageItems
      externalBom
      createdAt
      infoEffBulkDate
      infoFwt
      infoPallet
      infoRefPkg
      infoPacking
      barcodeFgCase
      barcodePkg
      orderType
      receiveDate
      barcodeEa
      alternativeText
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderPicklist = /* GraphQL */ `
  mutation DeleteDgtPdOrderPicklist(
    $input: DeleteDgtPdOrderPicklistInput!
    $condition: ModelDgtPdOrderPicklistConditionInput
  ) {
    deleteDgtPdOrderPicklist(input: $input, condition: $condition) {
      pk
      sk
      materialType
      materialCode
      materialDescription
      materialMrp
      orderQty
      materialUnit
      division
      kiNo
      batchLotNo
      trialBatch
      status
      returnStatus
      releasedDate
      releasedBy
      requestQty
      requestedDate
      requestedDateTime
      requestedBy
      withdrawQty
      draftedDate
      draftedBy
      approvedDate
      approvedDateTime
      approvedBy
      checkedDate
      checkedDateTime
      checkedBy
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      usedGoodQty
      usedWasteQty
      recordedDate
      recordedDateTime
      recordedBy
      completedDate
      completedDateTime
      completedBy
      returnGoodQty
      returnWasteQty
      receivedReturnDateTime
      receivedReturnBy
      commentText
      commentedBy
      commentActive
      id
      extraReturnId
      deprecated
      shortageItems
      externalBom
      createdAt
      infoEffBulkDate
      infoFwt
      infoPallet
      infoRefPkg
      infoPacking
      barcodeFgCase
      barcodePkg
      orderType
      receiveDate
      barcodeEa
      alternativeText
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderPicklistMovement = /* GraphQL */ `
  mutation CreateDgtPdOrderPicklistMovement(
    $input: CreateDgtPdOrderPicklistMovementInput!
    $condition: ModelDgtPdOrderPicklistMovementConditionInput
  ) {
    createDgtPdOrderPicklistMovement(input: $input, condition: $condition) {
      orderId
      sk
      materialCode
      materialDescription
      materialUnit
      materialType
      materialRequestQty
      documentYear
      documentNo
      documentItemNo
      documentCreatedAt
      movementType
      amount
      batchLotNo
      plant
      postingDate
      approvedDate
      approvedDateTime
      approvedBy
      checkedDate
      checkedDateTime
      checkedBy
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      id
      division
      usedGoodQty
      usedWasteQty
      returnGoodQty
      returnGoodShrinkQty
      returnWasteQty
      recordedDateTime
      recordedBy
      returnRefId
      extraRefId
      canceledDateTime
      canceledBy
      bulkUsedLogs
      wasteRecordedDate
      wasteRecordedDateTime
      wasteRecordedBy
      wasteRecordedStatus
      approvedWasteReturnDate
      approvedWasteReturnDateTime
      approvedWasteReturnBy
      otherQty
      vendorLotNo
      returnReasonCode
      returnReasonDescription
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderPicklistMovement = /* GraphQL */ `
  mutation UpdateDgtPdOrderPicklistMovement(
    $input: UpdateDgtPdOrderPicklistMovementInput!
    $condition: ModelDgtPdOrderPicklistMovementConditionInput
  ) {
    updateDgtPdOrderPicklistMovement(input: $input, condition: $condition) {
      orderId
      sk
      materialCode
      materialDescription
      materialUnit
      materialType
      materialRequestQty
      documentYear
      documentNo
      documentItemNo
      documentCreatedAt
      movementType
      amount
      batchLotNo
      plant
      postingDate
      approvedDate
      approvedDateTime
      approvedBy
      checkedDate
      checkedDateTime
      checkedBy
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      id
      division
      usedGoodQty
      usedWasteQty
      returnGoodQty
      returnGoodShrinkQty
      returnWasteQty
      recordedDateTime
      recordedBy
      returnRefId
      extraRefId
      canceledDateTime
      canceledBy
      bulkUsedLogs
      wasteRecordedDate
      wasteRecordedDateTime
      wasteRecordedBy
      wasteRecordedStatus
      approvedWasteReturnDate
      approvedWasteReturnDateTime
      approvedWasteReturnBy
      otherQty
      vendorLotNo
      returnReasonCode
      returnReasonDescription
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderPicklistMovement = /* GraphQL */ `
  mutation DeleteDgtPdOrderPicklistMovement(
    $input: DeleteDgtPdOrderPicklistMovementInput!
    $condition: ModelDgtPdOrderPicklistMovementConditionInput
  ) {
    deleteDgtPdOrderPicklistMovement(input: $input, condition: $condition) {
      orderId
      sk
      materialCode
      materialDescription
      materialUnit
      materialType
      materialRequestQty
      documentYear
      documentNo
      documentItemNo
      documentCreatedAt
      movementType
      amount
      batchLotNo
      plant
      postingDate
      approvedDate
      approvedDateTime
      approvedBy
      checkedDate
      checkedDateTime
      checkedBy
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      id
      division
      usedGoodQty
      usedWasteQty
      returnGoodQty
      returnGoodShrinkQty
      returnWasteQty
      recordedDateTime
      recordedBy
      returnRefId
      extraRefId
      canceledDateTime
      canceledBy
      bulkUsedLogs
      wasteRecordedDate
      wasteRecordedDateTime
      wasteRecordedBy
      wasteRecordedStatus
      approvedWasteReturnDate
      approvedWasteReturnDateTime
      approvedWasteReturnBy
      otherQty
      vendorLotNo
      returnReasonCode
      returnReasonDescription
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderPicklistExtraReturn = /* GraphQL */ `
  mutation CreateDgtPdOrderPicklistExtraReturn(
    $input: CreateDgtPdOrderPicklistExtraReturnInput!
    $condition: ModelDgtPdOrderPicklistExtraReturnConditionInput
  ) {
    createDgtPdOrderPicklistExtraReturn(input: $input, condition: $condition) {
      id
      orderId
      orderInfo
      requestMaterialType
      kiNo
      type
      status
      requestedDate
      requestedBy
      requestedDateTime
      approvedDate
      approvedBy
      approvedDateTime
      canceledDate
      canceledBy
      canceledDateTime
      withdrawedDate
      withdrawedBy
      withdrawedDateTime
      checkedDate
      checkedBy
      checkedDateTime
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      remark
      items
      extraReturnItems {
        items {
          id
          extraReturnId
          orderId
          materialCode
          materialDescription
          materialUnit
          batchLotNo
          qty
          withShQty
          wasteQty
          remark
          returnStorageLocation
          returnReasonCode
          returnReasonDescription
          active
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      documentNo
      documentYear
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderPicklistExtraReturn = /* GraphQL */ `
  mutation UpdateDgtPdOrderPicklistExtraReturn(
    $input: UpdateDgtPdOrderPicklistExtraReturnInput!
    $condition: ModelDgtPdOrderPicklistExtraReturnConditionInput
  ) {
    updateDgtPdOrderPicklistExtraReturn(input: $input, condition: $condition) {
      id
      orderId
      orderInfo
      requestMaterialType
      kiNo
      type
      status
      requestedDate
      requestedBy
      requestedDateTime
      approvedDate
      approvedBy
      approvedDateTime
      canceledDate
      canceledBy
      canceledDateTime
      withdrawedDate
      withdrawedBy
      withdrawedDateTime
      checkedDate
      checkedBy
      checkedDateTime
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      remark
      items
      extraReturnItems {
        items {
          id
          extraReturnId
          orderId
          materialCode
          materialDescription
          materialUnit
          batchLotNo
          qty
          withShQty
          wasteQty
          remark
          returnStorageLocation
          returnReasonCode
          returnReasonDescription
          active
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      documentNo
      documentYear
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderPicklistExtraReturn = /* GraphQL */ `
  mutation DeleteDgtPdOrderPicklistExtraReturn(
    $input: DeleteDgtPdOrderPicklistExtraReturnInput!
    $condition: ModelDgtPdOrderPicklistExtraReturnConditionInput
  ) {
    deleteDgtPdOrderPicklistExtraReturn(input: $input, condition: $condition) {
      id
      orderId
      orderInfo
      requestMaterialType
      kiNo
      type
      status
      requestedDate
      requestedBy
      requestedDateTime
      approvedDate
      approvedBy
      approvedDateTime
      canceledDate
      canceledBy
      canceledDateTime
      withdrawedDate
      withdrawedBy
      withdrawedDateTime
      checkedDate
      checkedBy
      checkedDateTime
      qualityCheckedDate
      qualityCheckedDateTime
      qualityCheckedBy
      remark
      items
      extraReturnItems {
        items {
          id
          extraReturnId
          orderId
          materialCode
          materialDescription
          materialUnit
          batchLotNo
          qty
          withShQty
          wasteQty
          remark
          returnStorageLocation
          returnReasonCode
          returnReasonDescription
          active
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      documentNo
      documentYear
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderPicklistExtraReturnItem = /* GraphQL */ `
  mutation CreateDgtPdOrderPicklistExtraReturnItem(
    $input: CreateDgtPdOrderPicklistExtraReturnItemInput!
    $condition: ModelDgtPdOrderPicklistExtraReturnItemConditionInput
  ) {
    createDgtPdOrderPicklistExtraReturnItem(
      input: $input
      condition: $condition
    ) {
      id
      extraReturnId
      orderId
      materialCode
      materialDescription
      materialUnit
      batchLotNo
      qty
      withShQty
      wasteQty
      remark
      returnStorageLocation
      returnReasonCode
      returnReasonDescription
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderPicklistExtraReturnItem = /* GraphQL */ `
  mutation UpdateDgtPdOrderPicklistExtraReturnItem(
    $input: UpdateDgtPdOrderPicklistExtraReturnItemInput!
    $condition: ModelDgtPdOrderPicklistExtraReturnItemConditionInput
  ) {
    updateDgtPdOrderPicklistExtraReturnItem(
      input: $input
      condition: $condition
    ) {
      id
      extraReturnId
      orderId
      materialCode
      materialDescription
      materialUnit
      batchLotNo
      qty
      withShQty
      wasteQty
      remark
      returnStorageLocation
      returnReasonCode
      returnReasonDescription
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderPicklistExtraReturnItem = /* GraphQL */ `
  mutation DeleteDgtPdOrderPicklistExtraReturnItem(
    $input: DeleteDgtPdOrderPicklistExtraReturnItemInput!
    $condition: ModelDgtPdOrderPicklistExtraReturnItemConditionInput
  ) {
    deleteDgtPdOrderPicklistExtraReturnItem(
      input: $input
      condition: $condition
    ) {
      id
      extraReturnId
      orderId
      materialCode
      materialDescription
      materialUnit
      batchLotNo
      qty
      withShQty
      wasteQty
      remark
      returnStorageLocation
      returnReasonCode
      returnReasonDescription
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdIAMUser = /* GraphQL */ `
  mutation CreateDgtPdIAMUser(
    $input: CreateDgtPdIAMUserInput!
    $condition: ModelDgtPdIAMUserConditionInput
  ) {
    createDgtPdIAMUser(input: $input, condition: $condition) {
      username
      employeeNo
      email
      firstName
      lastName
      department
      division
      line
      roles
      active
      id
      isAdmin
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdIAMUser = /* GraphQL */ `
  mutation UpdateDgtPdIAMUser(
    $input: UpdateDgtPdIAMUserInput!
    $condition: ModelDgtPdIAMUserConditionInput
  ) {
    updateDgtPdIAMUser(input: $input, condition: $condition) {
      username
      employeeNo
      email
      firstName
      lastName
      department
      division
      line
      roles
      active
      id
      isAdmin
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdIAMUser = /* GraphQL */ `
  mutation DeleteDgtPdIAMUser(
    $input: DeleteDgtPdIAMUserInput!
    $condition: ModelDgtPdIAMUserConditionInput
  ) {
    deleteDgtPdIAMUser(input: $input, condition: $condition) {
      username
      employeeNo
      email
      firstName
      lastName
      department
      division
      line
      roles
      active
      id
      isAdmin
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderInspectionLog = /* GraphQL */ `
  mutation CreateDgtPdOrderInspectionLog(
    $input: CreateDgtPdOrderInspectionLogInput!
    $condition: ModelDgtPdOrderInspectionLogConditionInput
  ) {
    createDgtPdOrderInspectionLog(input: $input, condition: $condition) {
      id
      productionOrderId
      workCenterId
      workCenterDescription
      machineId
      inspectionType
      inspectionStatus
      formName
      formUrl
      avgFwtByLots
      submittedDatetime
      submittedBy
      approvedDatetime
      approvedBy
      createdAt
      createdBy
      createdVersion
      updatedAt
      updatedBy
      updatedVersion
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderInspectionLog = /* GraphQL */ `
  mutation UpdateDgtPdOrderInspectionLog(
    $input: UpdateDgtPdOrderInspectionLogInput!
    $condition: ModelDgtPdOrderInspectionLogConditionInput
  ) {
    updateDgtPdOrderInspectionLog(input: $input, condition: $condition) {
      id
      productionOrderId
      workCenterId
      workCenterDescription
      machineId
      inspectionType
      inspectionStatus
      formName
      formUrl
      avgFwtByLots
      submittedDatetime
      submittedBy
      approvedDatetime
      approvedBy
      createdAt
      createdBy
      createdVersion
      updatedAt
      updatedBy
      updatedVersion
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderInspectionLog = /* GraphQL */ `
  mutation DeleteDgtPdOrderInspectionLog(
    $input: DeleteDgtPdOrderInspectionLogInput!
    $condition: ModelDgtPdOrderInspectionLogConditionInput
  ) {
    deleteDgtPdOrderInspectionLog(input: $input, condition: $condition) {
      id
      productionOrderId
      workCenterId
      workCenterDescription
      machineId
      inspectionType
      inspectionStatus
      formName
      formUrl
      avgFwtByLots
      submittedDatetime
      submittedBy
      approvedDatetime
      approvedBy
      createdAt
      createdBy
      createdVersion
      updatedAt
      updatedBy
      updatedVersion
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdOrderReceipt = /* GraphQL */ `
  mutation CreateDgtPdOrderReceipt(
    $input: CreateDgtPdOrderReceiptInput!
    $condition: ModelDgtPdOrderReceiptConditionInput
  ) {
    createDgtPdOrderReceipt(input: $input, condition: $condition) {
      id
      productionOrderId
      batchLotNo
      bulkUsage
      totalAmount
      avgFillingWeight
      retainedIssue
      microIssue
      validateIssue
      shelfLifeIssue
      testIssue
      otherIssue
      remark
      reject
      approvedByPdDate
      approvedByPdDatetime
      approvedByPdBy
      approvedByQcDate
      approvedByQcDatetime
      approvedByQcBy
      approvedByWhDate
      approvedByWhDatetime
      approvedByWhMonth
      approvedByWhBy
      approvedByFaDate
      approvedByFaDatetime
      approvedByFaBy
      createdAt
      createdBy
      createdVersion
      updatedAt
      updatedBy
      updatedVersion
      orderMaterialCode
      orderMaterialDesc
      orderType
      orderQty
      orderTags
      currentApprover
      isRework
      reworkedBy
      reworkedDatetime
      reworkNote
      otherIssueNote
      infoEaPerPack
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdOrderReceipt = /* GraphQL */ `
  mutation UpdateDgtPdOrderReceipt(
    $input: UpdateDgtPdOrderReceiptInput!
    $condition: ModelDgtPdOrderReceiptConditionInput
  ) {
    updateDgtPdOrderReceipt(input: $input, condition: $condition) {
      id
      productionOrderId
      batchLotNo
      bulkUsage
      totalAmount
      avgFillingWeight
      retainedIssue
      microIssue
      validateIssue
      shelfLifeIssue
      testIssue
      otherIssue
      remark
      reject
      approvedByPdDate
      approvedByPdDatetime
      approvedByPdBy
      approvedByQcDate
      approvedByQcDatetime
      approvedByQcBy
      approvedByWhDate
      approvedByWhDatetime
      approvedByWhMonth
      approvedByWhBy
      approvedByFaDate
      approvedByFaDatetime
      approvedByFaBy
      createdAt
      createdBy
      createdVersion
      updatedAt
      updatedBy
      updatedVersion
      orderMaterialCode
      orderMaterialDesc
      orderType
      orderQty
      orderTags
      currentApprover
      isRework
      reworkedBy
      reworkedDatetime
      reworkNote
      otherIssueNote
      infoEaPerPack
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdOrderReceipt = /* GraphQL */ `
  mutation DeleteDgtPdOrderReceipt(
    $input: DeleteDgtPdOrderReceiptInput!
    $condition: ModelDgtPdOrderReceiptConditionInput
  ) {
    deleteDgtPdOrderReceipt(input: $input, condition: $condition) {
      id
      productionOrderId
      batchLotNo
      bulkUsage
      totalAmount
      avgFillingWeight
      retainedIssue
      microIssue
      validateIssue
      shelfLifeIssue
      testIssue
      otherIssue
      remark
      reject
      approvedByPdDate
      approvedByPdDatetime
      approvedByPdBy
      approvedByQcDate
      approvedByQcDatetime
      approvedByQcBy
      approvedByWhDate
      approvedByWhDatetime
      approvedByWhMonth
      approvedByWhBy
      approvedByFaDate
      approvedByFaDatetime
      approvedByFaBy
      createdAt
      createdBy
      createdVersion
      updatedAt
      updatedBy
      updatedVersion
      orderMaterialCode
      orderMaterialDesc
      orderType
      orderQty
      orderTags
      currentApprover
      isRework
      reworkedBy
      reworkedDatetime
      reworkNote
      otherIssueNote
      infoEaPerPack
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createDgtPdMovementReason = /* GraphQL */ `
  mutation CreateDgtPdMovementReason(
    $input: CreateDgtPdMovementReasonInput!
    $condition: ModelDgtPdMovementReasonConditionInput
  ) {
    createDgtPdMovementReason(input: $input, condition: $condition) {
      id
      reasonCode
      reasonDesciption
      movementType
      componenType
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const updateDgtPdMovementReason = /* GraphQL */ `
  mutation UpdateDgtPdMovementReason(
    $input: UpdateDgtPdMovementReasonInput!
    $condition: ModelDgtPdMovementReasonConditionInput
  ) {
    updateDgtPdMovementReason(input: $input, condition: $condition) {
      id
      reasonCode
      reasonDesciption
      movementType
      componenType
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const deleteDgtPdMovementReason = /* GraphQL */ `
  mutation DeleteDgtPdMovementReason(
    $input: DeleteDgtPdMovementReasonInput!
    $condition: ModelDgtPdMovementReasonConditionInput
  ) {
    deleteDgtPdMovementReason(input: $input, condition: $condition) {
      id
      reasonCode
      reasonDesciption
      movementType
      componenType
      active
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
export const createUserCognito = /* GraphQL */ `
  mutation CreateUserCognito($username: String) {
    createUserCognito(username: $username)
  }
`;
export const addUserToAdminsCognito = /* GraphQL */ `
  mutation AddUserToAdminsCognito($username: String, $isRemove: Boolean) {
    addUserToAdminsCognito(username: $username, isRemove: $isRemove)
  }
`;
export const resetPassword = /* GraphQL */ `
  mutation ResetPassword($username: String) {
    resetPassword(username: $username)
  }
`;
export const notifyQCLine = /* GraphQL */ `
  mutation NotifyQCLine(
    $pdOrder: String
    $division: String
    $claimMaterials: String
  ) {
    notifyQCLine(
      pdOrder: $pdOrder
      division: $division
      claimMaterials: $claimMaterials
    )
  }
`;
export const generateFGInspectionForms = /* GraphQL */ `
  mutation GenerateFGInspectionForms(
    $form_type: String
    $pd_order: String
    $material_code: String
    $material_name: String
    $date: String
    $product_profile: String
    $line_no: String
    $line_desc: String
    $std_fwt: String
    $bulk_code: String
    $bulk_description: String
  ) {
    generateFGInspectionForms(
      form_type: $form_type
      pd_order: $pd_order
      material_code: $material_code
      material_name: $material_name
      date: $date
      product_profile: $product_profile
      line_no: $line_no
      line_desc: $line_desc
      std_fwt: $std_fwt
      bulk_code: $bulk_code
      bulk_description: $bulk_description
    ) {
      status
      message
      path
      name
      eTag
      workUrl
      __typename
    }
  }
`;
export const getAverageFillingWeight = /* GraphQL */ `
  mutation GetAverageFillingWeight(
    $pd_order: String
    $form_type: String
    $line_no: String
  ) {
    getAverageFillingWeight(
      pd_order: $pd_order
      form_type: $form_type
      line_no: $line_no
    ) {
      message
      avgFwtByLots {
        BATCH_LOT
        AVG_FWT
        __typename
      }
      __typename
    }
  }
`;
export const notifyReceiptRejected = /* GraphQL */ `
  mutation NotifyReceiptRejected(
    $pdOrder: String
    $rejectFromDepartment: String
    $rejectToDepartment: String
    $rejectedAt: String
    $rejectNote: String
    $division: String
  ) {
    notifyReceiptRejected(
      pdOrder: $pdOrder
      rejectFromDepartment: $rejectFromDepartment
      rejectToDepartment: $rejectToDepartment
      rejectedAt: $rejectedAt
      rejectNote: $rejectNote
      division: $division
    )
  }
`;
export const generateFGInspectionExistForm = /* GraphQL */ `
  mutation GenerateFGInspectionExistForm(
    $form_type: String
    $pd_order: String
    $material_code: String
    $material_name: String
    $date: String
    $product_profile: String
    $line_no: String
    $line_desc: String
    $std_fwt: String
    $bulk_code: String
    $bulk_description: String
    $previous_line_no: String
  ) {
    generateFGInspectionExistForm(
      form_type: $form_type
      pd_order: $pd_order
      material_code: $material_code
      material_name: $material_name
      date: $date
      product_profile: $product_profile
      line_no: $line_no
      line_desc: $line_desc
      std_fwt: $std_fwt
      bulk_code: $bulk_code
      bulk_description: $bulk_description
      previous_line_no: $previous_line_no
    ) {
      status
      message
      path
      name
      eTag
      workUrl
      __typename
    }
  }
`;
